import { useQuery } from "@tanstack/react-query"
import { ApplicationPermissionGet } from "../app/models/ApplicationPermission"
import { digitalManagerApi } from "../services/api"

export function useApplicationPermissions(applicationId?: string) {
  const {
    data: applicationPermissions = [],
    isLoading: isLoadingApplicationPermissions,
  } = useQuery({
    queryKey: ["applicationPermissions", applicationId],
    queryFn: () =>
      digitalManagerApi
        .get<ApplicationPermissionGet[]>(`/applications/${applicationId}/permissions`)
        .then((r) => r.data),
    enabled: !!applicationId,
  })

  return {
    applicationPermissions,
    isLoadingApplicationPermissions,
  }
}
